import styled from 'styled-components/macro';

const ResetPasswordWrapper = styled.div`
  display: flex;
  flex-direction: column;

  min-height: 100%;
`;

export default ResetPasswordWrapper;
